import { Route, Routes } from 'react-router-dom';
import { AuthorizedElement } from "rwo-react";
import Home from "./pages/Home";
import Unauthorized from "./pages/Unauthorized";
import { UXPermissions } from "./permissions/UXPermissions";

function App() {
  return (
    <Routes>
      <Route
        path="*"
        element={
          <AuthorizedElement
            resourceId={UXPermissions.LMSEventDefinitionToolAccess.resourceId}
            permissionAction={UXPermissions.LMSEventDefinitionToolAccess.action}>
            <Home />
          </AuthorizedElement>
        }
      />
      <Route path="/unauthorized" element={<Unauthorized />} />
    </Routes>
  );
}

export default App;
